import api from './api';

export interface AudienceMetrics {
  totalAudience: number;
  reachableHouseholds: number;
}

interface AudienceMetricsResponse {
  totalCount: number;
  emailCount: number;
  phoneCount: number;
  deviceCount: number;
  iPCount: number;
  inmCount: number;
}

export const getAudienceMetrics = async (segmentIds: string[], zipCodes: string[]): Promise<AudienceMetricsResponse> => {
  if (!segmentIds?.length || !zipCodes?.length) {
    throw new Error('Both segment IDs and ZIP codes are required');
  }

  try {
    console.log('Fetching audience metrics', {
      zipCodes: zipCodes.length,
      segmentIds: segmentIds.length
    });

    const response = await api.post('/api/audience/metrics', {
      segmentIds,
      zipCodes
    });

    console.log('Successfully fetched audience metrics:', response.data);

    return response.data;
  } catch (error) {
    console.error('Error fetching audience metrics:', error);
    throw new Error(error?.response?.data?.error || 'Failed to fetch audience metrics');
  }
};

export const validateAudience = async (
  zipCodes: string[],
  segmentIds: string[]
): Promise<{ valid: boolean; message?: string }> => {
  try {
    console.log('Validating audience selection', {
      zipCodes: zipCodes.length,
      segmentIds: segmentIds.length
    });

    const response = await api.post('/api/audience/validate', {
      zipCodes,
      segmentIds
    });

    console.log('Audience validation result:', response.data);

    return response.data;
  } catch (error) {
    console.error('Error validating audience:', error);
    throw new Error(error?.response?.data?.error || 'Failed to validate audience selection');
  }
};

export const getAudienceRecommendations = async (
  zipCodes: string[]
): Promise<string[]> => {
  try {
    console.log('Fetching audience segment recommendations for zip codes:', zipCodes);

    const response = await api.post('/api/audience/recommendations', {
      zipCodes
    });

    console.log('Successfully fetched segment recommendations:', response.data);

    return response.data.recommendations;
  } catch (error) {
    console.error('Error fetching audience recommendations:', error);
    throw new Error(error?.response?.data?.error || 'Failed to fetch audience recommendations');
  }
};

export const updateAudience = async (segmentIds: string[]): Promise<AudienceMetricsResponse> => {
  console.log('Making audience metrics request with:', {
    segmentIds,
    hasLength: Array.isArray(segmentIds) && segmentIds.length > 0
  });

  try {
    const response = await api.post('/api/audience/metrics', { segmentIds });
    console.log('Response from backend:', response);
    return response.data;
  } catch (error) {
    console.error('Error in updateAudience:', {
      error,
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    throw error;
  }
};

export const getEpekAudienceMetrics = async (segmentIds: string[]): Promise<AudienceMetricsResponse> => {
  console.log('Fetching audience metrics for segments:', segmentIds);

  try {
    const response = await api.post('/api/audience/metrics', { segmentIds });
    console.log('Audience metrics response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching audience metrics:', error);
    throw error;
  }
};